import {register} from '@shopify/theme-sections';

const sectionType = 'spend-and-win';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      this.checkForCustomerLogin();
    },

    checkForCustomerLogin() {
      document.addEventListener('status:shopify:login', () => {
        location.href = location.href.split('#')[0];
      });
    },
  });
